module.exports = __webpack_public_path__ + "dc38850fcde11783cbaf0a0070c05887.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Presnajderova.png
// module id = neNZ
// module chunks = 0